import { reportError } from "./error_reporting";

const { fetch: originalFetch } = window;

window.fetch = async (...args) => {
  const [resource, config] = args;
  const response = await originalFetch(resource, config);
  if (!response.ok) {
    const requestId = response.headers.get("X-Request-Id");
    reportError(response.statusText, requestId ? { requestId } : undefined);

    return Promise.reject(response);
  }
  return response;
};
